import React, { Fragment } from 'react';

import { figure, rate } from './contractorFormat';

import { ZERO_DASH } from 'Helpers/formatService';

import Badge from 'CommonComponents/Badge';
import TableRowSkeleton from 'CommonComponents/TableRowSkeleton';

import ChevronDownIcon from 'Assets/icons/chevron-down.svg';
import ChevronUpIcon from 'Assets/icons/chevron-up.svg';

const COLUMNS = 10;

export default function VenueContractorsByPackTable({ rows, totals, loading, expanded, onToggle }) {
    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table tw-min-w-[64rem]">
                <thead>
                    <tr>
                        <th className="!tw-text-start">{$t('Pack')}</th>
                        <th className="!tw-text-start">{$t('Functional area')}</th>
                        <th>{$t('Days')}</th>
                        <th>{$t('Session / non-session')}</th>
                        <th>{$t('People per shift')}</th>
                        <th>{$t('Days with 2+ shifts')}</th>
                        <th>{$t('Contractor shifts')}</th>
                        <th>{$t('Hours')}</th>
                        <th>{$t('Cost')}</th>
                        <th>{$t('Avg cost / day')}</th>
                    </tr>
                </thead>
                <tbody>
                    {loading && <TableRowSkeleton rows={5} columns={COLUMNS} />}
                    {!loading && rows.map((pack) => <PackRow key={pack.id} pack={pack} show={!!expanded[pack.id]} onToggle={() => onToggle(pack.id)} />)}
                </tbody>
                {!loading && totals && (
                    <tfoot>
                        <tr>
                            <td>{$t('Total')}</td>
                            <td />
                            <td className="inbud-numeric-cell">{figure(totals.days)}</td>
                            <td />
                            <td />
                            <td />
                            <td className="inbud-numeric-cell">{figure(totals.shifts)}</td>
                            <td className="inbud-numeric-cell">{figure(totals.hours)}</td>
                            <td className="inbud-numeric-cell">{figure(totals.cost)}</td>
                            <td />
                        </tr>
                    </tfoot>
                )}
            </table>
        </div>
    );
}

function PackRow({ pack, show, onToggle }) {
    return (
        <Fragment>
            <tr className="tw-cursor-pointer" onClick={onToggle}>
                <td className="tw-font-semibold">
                    {/* Enter / Space on the button fire a click that bubbles to the row's onClick. */}
                    <button type="button" aria-expanded={show} className="tw-flex tw-items-center tw-gap-x-1.5 tw-text-start tw-font-semibold">
                        {show ? <ChevronUpIcon className="tw-shrink-0" aria-hidden="true" /> : <ChevronDownIcon className="tw-shrink-0" aria-hidden="true" />}
                        <span>{pack.name}</span>
                    </button>
                </td>
                <td>{pack.department && <Badge variant="info">{pack.department.name}</Badge>}</td>
                <td className="inbud-numeric-cell">{figure(pack.days)}</td>
                <td className="inbud-numeric-cell">
                    {pack.session_days} / {pack.non_session_days}
                </td>
                <td className="inbud-numeric-cell">{figure(pack.people_per_shift)}</td>
                <td className="inbud-numeric-cell">{figure(pack.multi_shift_days)}</td>
                <td className="inbud-numeric-cell">{figure(pack.shifts)}</td>
                <td className="inbud-numeric-cell">{figure(pack.hours)}</td>
                <td className="inbud-numeric-cell">{figure(pack.cost)}</td>
                <td className="inbud-numeric-cell">{figure(pack.avg_cost_per_day)}</td>
            </tr>
            {show && (
                <Fragment>
                    <tr className="!tw-bg-white tw-text-xs tw-font-semibold tw-text-charcoal-75">
                        <td className="!tw-ps-8">{$t('Role')}</td>
                        <td />
                        <td className="tw-text-end">{$t('Qty per shift')}</td>
                        <td className="tw-text-end">{$t('Rate / hr')}</td>
                        <td colSpan={2}>{$t('Shift rule')}</td>
                        <td className="tw-text-end">{$t('Shifts')}</td>
                        <td className="tw-text-end">{$t('Hours')}</td>
                        <td className="tw-text-end">{$t('Cost')}</td>
                        <td />
                    </tr>
                    {pack.roles.map((role) => (
                        <tr key={role.id} className="!tw-bg-white">
                            <td className="!tw-ps-8">{role.name}</td>
                            <td />
                            <td className="inbud-numeric-cell">{role.qty_per_shift === null ? ZERO_DASH : figure(role.qty_per_shift)}</td>
                            <td className="inbud-numeric-cell">{rate(role.rate)}</td>
                            <td colSpan={2} className="tw-text-charcoal-75">
                                {role.shift_rule || ''}
                            </td>
                            <td className="inbud-numeric-cell">{figure(role.shifts)}</td>
                            <td className="inbud-numeric-cell">{figure(role.hours)}</td>
                            <td className="inbud-numeric-cell">{figure(role.cost)}</td>
                            <td />
                        </tr>
                    ))}
                </Fragment>
            )}
        </Fragment>
    );
}
